import {observable} from 'mobx';

/*
Every text message in the UI is looked up through the functionality of this
module, thus allowing different language versions of the UI.
*/

/*
These are the hard-coded default messages that will be used, unless another
set of messages are installed.



*/
let messages = {

  // Messages not connected to a particular page:
  ID:"Id",
  CUSTOMER_ID:"Customer Id",
  CUSTOMER:"Customer",
  MACHINE_ID:"Machine Id",
  MACHINE:"Machine",
  STATUS:"Status",
  NAME:"Name",
  MODEL:"Model",
  SOFTWARE:"Software",
  TYPE:"Type",
  START_DATE:"Start date",
  END_DATE:"End date",
  OK:'OK',
  SEARCH:"Search",
  SERVER_FAILED:'Server operation failed',
  TF_NO_TIMESTAMP:"No timestamp",
  TF_NO_DATE:"No date",
  ALL: "All",

  // Navigation main menu names
  N_AUDIT_LOG:"Audit log",
  N_HOME:"Home",
  N_JOBS:"Jobs",
  N_MACHINES:"Machines",
  N_ROOMS:"Rooms",
  N_CUSTOMERS:"Customers",
  N_MACHINE_ADMIN:"Machine Admin",
  N_REPORTS:"Reports",
  N_SETTINGS:"Settings",
  N_VERIFY_PHONE:"Verify phone number",
  N_USER_ADMIN:"User admin",
  N_LOGIN_AS:"Login as ..",
  N_DELETED:"Deleted",
  N_LOGOUT:"Logout",
  N_SUPPORT:"Support",
  N_USER_MANUAL:"User Documentation",
  N_BEACONS: "Beacons",
  N_SIMCARDS:"SIM Cards",

  // Page titles
  PT_AUDIT_LOG:"Audit log",
  PT_DECONX:"Decon-X",
  PT_LOGGED_OUT:"Logged Out",
  PT_ROOMS:"Rooms",
  PT_ADD_NEW_LOCATION:"Add new location",
  PT_EDIT_LOCATION:"Edit location",
  PT_SETTINGS:"Settings",
  PT_LOGIN_AS:"Log in as user",
  PT_USER_ADMIN:"User administration",
  PT_EDIT_USER:"Edit user",
  PT_ADD_NEW_USER:"Add new user",
  PT_CONFIRM_PHONE_NUMBER:"Confirm phone number",
  PT_REPORTS:"Reports",
  PT_SUPPORT:"Support",
  PT_DELETED:"Deleted",
  PT_RECENT_JOBS:"Recent jobs",
  PT_JOB_DETAILS:"Job details",
  PT_GRAPH_PAGE:"Graph page",
  PT_MACHINES:"Machines",
  PT_MACHINE_DETAIL:"Machine detail",
  PT_MACHINE_CONFIG:"Machine configuration",
  PT_CUSTOMERS:"Customers",
  PT_REGISTER_NEW_CUSTOMER:"Register new customer",
  PT_EDIT_CUSTOMER:"Edit customer",
  PT_MACHINE_ADMIN:"Machine Administration",
  PT_NEW_MACHINE_REGISTRATION:"New machine registration",
  PT_MACHINE_REASSIGN:"Machine (re)assignment",
  PT_MACHINE_CONTRACTS:"Machine contracts",
  PT_EDIT_CONTRACTS:"Edit contract",
  PT_NEW_CONTRACTS:"New contract",
  PT_USER_MANUAL:"User Documentation",
  PT_BEACONS:"Beacons",
  PT_SIMCARD:"SIM Card",
  PT_SIMCARDS:"SIM Cards",

  // Home page / dashboard page :
  HP_NO_RUNNING:"No running jobs found.",
  HP_JOBS_LISTED_HERE:"Jobs started by you or your colleagues will be listed here.",
  HP_B_REFRESH_JOBLIST:"Refresh joblist",
  HP_H_RUNNING:"Your running jobs",

  // Job List
  JL_COMPLETED_JOBS:"Completed Jobs",
  JL_ROOM:"Room",
  JL_MACHINE:"Machine",
  JL_USER:"User",
  JL_STATUS:"status",
  JL_JOB_RAN_FOR: min => `Job ran for ${min} minutes`,

  // Job List Element component
  JLE_JOB_PHASE_UNKNOWN:"Job phase unknown (offline)",
  JLE_NO_PHASE_INFO_FOR_JOB:"No phase info on job",
  JLE_PROCESS_STAGE:"Process stage",
  JLE_ROOM_NAMED: name => `Room: ${name}`,
  JLE_MACHINE_NAMED: name => `Machine: ${name}`,
  JLE_USER_STARTED_JOB: (user, time) => `${user} started job at ${time}`,
  JLE_OFFLINE_LAST_STARTED: time => `Machine offline, last job started at ${time}`,
  JLE_JOB_STARTED_AND_TIME_LEFT: (started,timeleft) =>
    `Job started at started at ${started}, ${timeleft} left`,
  JLE_JOB_ENDED: time => `Job ended at ${time}`,
  JLE_DISINFECTION_MACHINE_OFFLINE:"Disinfection machine offline.",
  JLE_NO_MEASUREMENTS_IN_5:"We have not received measurements from this job in 5 minutes.",
  JLE_CONCENTRATION_LEVEL:"concentration level",
  JLE_CURRENT_PPM_LEVEL: level => `Current: ${level} ppm`,
  JLE_AVG_PPM_LEVEL: level => `Average: ${level} ppm`,
  JLE_DO_NOT_ENTER_UNTIL:"Do not enter room until ",
  JLE_BELOW_SAFE_LEVEL:" concentration level is below safety limit.",
  JLE_B_SEE_DETAILS:"See details",
  JLE_B_SEE_GRAPH:"See graph",

  // Job page
  JB_AVG_H2O2:"Average H<sub>2</sub>O<sub>2</sub>",
  JP_CURR_H2O2:"Current H<sub>2</sub>O<sub>2</sub>",
  JP_ALARMS_DURING: num => num + " alarm(s) during job",
  JP_ALARMS_REGISTERED_DURING: num => num + " alarm(s) during job",
  JP_ROOM:"Room",
  JP_VOLUME:"Volume",
  JP_MACHINE:"Machine",
  JP_OPERATOR:"Operator",
  JP_JOB_STARTED:"Job started",
  JP_JOB_ENDED:"Job ended",
  JP_RESULT:"Result",
  JP_B_SEE_GRAPH:"See graph",
  JP_B_RESEND_PDF:"Resend PDF report (email)",
  JP_FLUID:"Fluid",
  JP_FLUID_ID:"Fluid id",
  JP_JOB_TYPE:"Disinfection type",

  // Machine list
  ML_JOB_RUNNING:"Currently running disinfection job.  Job started at ",
  ML_NO_LAST_JOB:"No last job registered",
  ML_LAST_JOB_COMPLETED: completed => `Last job completed at ${completed}`,

  // Machine page
  MP_H_CONTRACT:"Contract",
  MP_H_MACHINE:"Machine",
  MP_FLUID_TANK:'Fluid tank',
  MP_HUMIDITY:'Humidity',
  MP_H2O2:'H2O2',
  MP_H2O2_EXT:'H2O2 ext',
  MP_TEMP_ROOM:'Temperature room',
  MP_TEMP_COMPRESSOR:'Temperature compressor',
  MP_ONLINE_JOB_RUN:"Online, running job.",
  MP_UNKNOWN:'Unknown',
  MP_ONLINE_NO_JOB:"Online. Not running job.",
  MP_OFFLINE_SINCE: lastRead => `Offline since ${lastRead}`,
  MP_B_ASSIGN_MACHINE:"Assign machine to customer",
  MP_SUPPORT_PAID_TILL:"Support validity",
  MP_B_MANAGE_CONTRACTS:"Manage contracts",
  MP_MACHINE_CONFIG:"Machine configuration",
  MP_B_EDIT_CONFIG:"Edit configuration",
  MP_B_SHOW_CONFIG:"Show machine configuration",
  MP_B_HIDE_CONFIG:"Hide configuration",

  MP_SIM_CARD_STATUS:"SIM Card Status",
  MP_SIM_NOT_INSTALLED:"SIM card not installed",
  MP_B_ACTIVATE_SIM:"Activate Sim Card",
  MP_B_DEACTIVATE_SIM:"Deactivate Sim Card",
  MP_SIM_STATE_LOADING:"SIM state loading",
  MP_SIM_NOT_ACTIVATED:"SIM card not activated",
  MP_SIM_ACTIVATED:"SIM card activated",

  // Machine assignment page
  AP_EXAMPLE_MACHINE_NAME:"E.g. 'DECONX34'",
  AP_CUSTOMER_MACHINE_NAME:"Machine name at customer",
  AP_MACHINE_ID_REQ:"Machine Id (required)",
  AP_MACHINE_CUST_NAME:"Machine name at customer's",
  AP_MACHINE_CUST_NAME_REQ:"Machine name at customer's (required)",
  AP_B_CANCEL:"Cancel",
  AP_B_UPDATE:"Update",

  // Customer select component:
  CS_SELECT_CUST:"Select customer",
  CS_HINT_TEXT:"Start typing name of customer",

  // Machine Contracts page:
  MC_DELIVERY_INFO: delDate => `Delivery: ${delDate}`,
  MC_SUPPORT_TILL_INFO: tillDate => `Support paid till ${tillDate}`,
  MC_END_OF_CONTRACT: endDate => `Rental ends ${endDate}`,
  MC_NO_CONTRACTS_REG_FOR:"No contracts registered for :",
  MC_CUSTOMER_NAME:'Customer',
  MC_MACHINE_NAME:'Machine',
  MC_CONTRACT_TYPE:'Type',
  MC_CREATED_AT: created => `Created at ${created}`,

  // New contract page
  NC_NEW_CONTRACT_FOR:"New contract for:",
  NC_CONTRACT_TYPE:"Contract type",
  NC_CONTRACT_TYPE_HINT:"select type of contract",
  NC_SUPPORT_AGREEMENT:'Support agreement (customer owns machine)',
  NC_MACHINE_SUPPORT:'Support agreement',
  NC_MACHINE_BUY:'Machine purchase agreement',
  NC_MACHINE_RENTAL:'Machine rental',
  NC_DELIVERY_DATE:"Delivery date",
  NC_DELIVERY_DATE_HINT:"When will the machine be delivered",
  NC_CONTRACT_END_DATE:"Contract end date",
  NC_CONTRACT_END_DATE_HINT:"End of hire period",
  NC_SUPPORT_START_DATE:"Support contract start date",
  NC_SUPPORT_START_DATE_HINT:"The date the support contract starts",
  NC_SUPPORT_PAID_TILL:"Support contract end date",
  NC_SUPPORT_PAID_TILL_HINT:"End of support period",
  NC_CANCEL:'Cancel',
  NC_INSERT:'Insert',

  // Edit contract page
  EC_EDIT_CONTRACT:"Edit contract",
  EC_CONTRACT_CREATED:"Contract created",
  EC_CONTRACT_TYPE:"Contract type",
  EC_CONTRACT_TYPE_HINT:"select type of contract",
  EC_SUPPORT_AGREEMENT:'Support agreement (customer owns machine)',
  EC_MACHINE_RENTAL:'Machine rental',
  EC_DELIVERY_DATE:"Delivery date",
  EC_DELIVERY_DATE_HINT:"When will the machine be delivered",
  EC_CONTRACT_END_DATE:"Contract end date",
  EC_CONTRACT_END_DATE_HINT:"End of hire period",
  EC_SUPPORT_PAID_TILL:"Support paid till",
  EC_SUPPORT_PAID_TILL_HINT:"End of support period",  

  // User Admin page
  UA_USERS_IN_AREA:"Users in your area",

  // Settings page
  SP_INSUFFICIENT_PERM:"Insufficient permissions",
  SP_NO_MODIFY_PERM:"You do not have permission to modify user accounts. Talk to your local area or system administrator to have permissions changed.",
  SP_SERVER_OP_FAILED:"Server operation failed",
  SP_UPDATE_USER_INFO:"Update user information",
  SP_LOGIN:"Login name",
  SP_LOGIN_HINT:"login",
  SP_FULL_NAME:"Full name",
  SP_FULL_NAME_HINT:"Full name of user.",
  SP_LOGIN_EMAIL:"Email (used to log in)",
  SP_LOGIN_EMAIL_HINT:"Signup email.",
  SP_INVALID_EMAIL:"Invalid email address",
  SP_EMAIL_CLAIMED:"Another user registered with this email",
  SP_PASSWORD:"Password (change)",
  SP_PASSWORD_HINT:"New password for user",
  SP_REPEAT_PASSWORD:"Repeat password",
  SP_REPEAT_PASSWORD_HINT:"Repeat password",
  SP_PASSWORD_DONT_MATCH:"Passwords do not match",
  SP_MOBILE_PHONE:"Mobile phone (international format including country code)",
  SP_MOBILE_PHONE_HINT:"Mobile phone",
  SP_MOBILE_NEEDS_VERIFICATION:"Phone number needs verification",
  SP_SENDING_TEST_SMS:"Sending test SMS",
  SP_B_SEND_TEST_SMS:"Send test SMS",
  SP_NOTIFICATIONS_LABEL:"Notifications (SMS)",
  SP_NOTIFICATION_INFO:"Receive SMS on alarms when jobs you start are complete",
  SP_NOTIFICATION_REQUIRE_PHONE:"Register mobile phone number above to enable this option",
  SP_JOB_REPORT_LABEL:"Job Reports (email)",
  SP_JOB_REPORT_INFO:"Get status reports for completed jobs",
  SP_INFO_EMAIL_INFO:"I want to receive information from Decon-X on e-mail",
  SP_INFO_EMAIL_LABEL:"Information (email)",
  SP_DELETE_USER:"Delete user",
  SP_DELETE_AND_DEACTIVATE:"Delete (and deactivate login for) this user ?",
  SP_CANCEL:"Cancel",
  SP_DELETE:"Delete",
  SP_UPDATE:"Update",

  // Confirm phone page
  CP_SMS_CODE_SENT:"SMS with verification code sent to phone.",
  CP_PHONE_CONFIRMED:"Phone number successfully confirmed.",
  CP_PHONE_CODE_REJECTED:"Verification code not accepted.  Verify that you have typed the code correctly, or request a new code to be sent.",
  CP_VERIFICATION_SENT_LABEL:"A verification code has been sent to the phone number below.",
  CP_ENTER_VERIFICATION:"Enter verification code received in SMS",
  CP_ENTER_VERIFICATION_HINT:"Verification code",
  CP_B_VERIFY_CODE:"Verify code",
  CP_NOT_RECEIVED:"If you have not received a code, double check the phone number and click button below.",
  CP_PHONE_NUMBER:"Mobile phone (international format including country code)",
  CP_PHONE_NUMBER_HINT:"Mobile phone",
  CP_B_SEND_VERIFY_CODE:"Send new SMS verification code",

  // Logged out page
  LO_LOGGED_OUT:"You have been logged out",
  LO_LOG_IN:"Log in",

  // Support info page
  SI_CONTACT_US:"Contact us",
  SI_PHONE:"Telephone",
  SI_PHONE_HOURS:'<a href="tel:+4722165160">(+47) 22 16 51 60</a> (Monday-Friday 08:00-16:00)',
  SI_EMAIL_LABEL:"Email",

  // Customer Edit page
  CE_EDIT_DATA_FOR:"Edit customer data for",
  CE_UPDATE:"Update",
  CE_CANCEL:"Cancel",

  // Customer Edit component
  CE_CUSTOMER_NAME:"Customer name (Required)",
  CE_CUSTOMER_NAME_HINT:"Name of customer",
  CE_ACCOUNT_ID:"Decon-X Account Id",
  CE_ACCOUNT_ID_HINT:"Account Id",
  CE_JOB_TYPES_AVAIL:"Job types available to customer",
  CE_CUSTOMER_IS_DISTRIBUTOR:"Customer is distributor",
  CE_IS_DISTRIBUTOR_CHECKTEXT:"Can create and administrate own customers",

  // Select country code component
  SC_SELECT_COUNTRY:"Select country",
  SC_SELECT_COUNTRY_HINT:"Select country",
  // Hard coded values for some country names.  As new countries are added to
  // the supported_countries table, translations needs to be added to the
  // ui_message table with key: COUNTRY_NAME_<country_code>
  // as seen in these examples :
  COUNTRY_NAME_NO:"Norway",
  COUNTRY_NAME_EN:"England",

  // Select language code component
  SL_SELECT_LANGUAGE:"Select language",
  SL_SELECT_LANGUAGE_HINT:"Select language",
  // Hard coded values for some language names.  As new languages are added to
  // the supported_languages table, translations needs to be added to the
  // ui_message table with key: LANGUAGE_NAME_<language_code>
  // as seen in these examples :
  LANGUAGE_NAME_NO:"Norwegian",
  LANGUAGE_NAME_EN:"English",

  // Select customer segment component
  SS_CUSTOMER_SEGMENT:"Customer segment",
  SS_CUSTOMER_SEGMENT_HINT:"Customer segment",

  // Hard coded values for some customer segment.  As new segments are added to
  // the customer_segments table, translations needs to be added to the
  // ui_message table with key: SEGMENT_TYPE_NAME_<segment_id>
  // as seen in these examples :
  SEGMENT_TYPE_NAME_HEALTH:"Health institution",
  SEGMENT_TYPE_NAME_PRIVATE:"Private institution",

  // Customers page
  CSP_ACCOUNT:"Account",
  CSP_COUNTRY:"Country",
  CSP_SEGMENT:"Segment",

  // Customer User List component:
  CUL_LOADING_USERS:"Loading users ..",
  CUL_SELECT_USER:"Select user to log in as",

  // Customer Machine List component:
  CML_LOADING_MACHINES:"Loading machines ..",
  CML_SELECT_MACHINE:"Select customer and machine",

  // Register customer page
  RC_CUSTOMER_ID_REQ:"Customer Id (Required)",
  RC_CUSTOMER_ID_REQ_HINT:"Customer Id",
  RC_EMAIL_LOGIN:"Email (used to log in from web)",
  RC_EMAIL_LOGIN_HINT:"Email used for login.",
  RC_INVALID_EMAIL:"Invalid email address",
  RC_ADDRESS_TAKEN:"Address registered with existing user",
  RC_FULL_NAME:"Full name",
  RC_FULL_NAME_HINT:"Full name of user.",
  RC_USERNAME:"Username",
  RC_USERNAME_HINT:"Username for logging into disinfection machine.",
  RC_PASSWORD:"Password, to be communicated to user",
  RC_PASSWORD_HINT:"Password",
  RC_CANCEL:"Cancel",
  RC_SUBMIT:"Submit",
  RC_INITIAL_ADMIN_USER:"Initial admin user",
  RC_REGISTER_CUSTOMER:"Register customer",
  RC_ID_IN_USE:"This id is already in use",
  RC_ID_MAX_LENGTH:"Maximum length of customer id is 36 characters",

  // Deletions (undelete) page
  DP_LOCATION:"Location",
  DP_LOCATION_TITLE_PLURAL: count => `${count} locations`,
  DP_ROOM_NAMES: nameliststr => `Rooms: ${nameliststr} `,
  DP_ROOM_NAME: name => `Room name: ${name} `,
  DP_ACCOUNT_TITLE: id => `User account: ${id} `,
  DP_DELETE_OPS_LAST30D:"Delete operations, last 30 days",
  DP_RESTORE_MENU_ITEM:"Restore",

  // New User page
  NU_USER_ID:"User identity",
  NU_FULL_NAME:"Full name",
  NU_FULL_NAME_HINT:"Full name of user.",
  NU_USERNAME:"Username",
  NU_USERNAME_HINT:"The username for logging into disinfection machine.",
  NU_USERNAME_TAKEN:"Username already taken, pick another",
  NU_EMAIL:"Email (used to log in from web)",
  NU_EMAIL_HINT:"Email used for login.",
  NU_INVALID_EMAIL:"Invalid email address",
  NU_EMAIL_TAKEN:"Address registered with existing user",
  NU_PASSWORD:"Password, to be communicated to user",
  NU_PASSWORD_HINT:"Password",
  NU_CLOSE:"Close",
  NU_CANCEL:"Cancel",

  // Room page
  RM_LAST_DISINFECTED: lastTime => `Last disinfected: ${lastTime}`,
  RM_ROOMS:'rooms',
  RM_USERS:'users',
  RM_AREAS_AND_ROOMS:"Areas and Rooms",

  // New Room page
  NR_NAME_PROMPT: typename => `Name of ${typename}`,
  NR_NAME_PROMPT_REQ: typename => `Name of ${typename} (required)`,
  NR_NAME_PROMPT_HINT:"E.g. 104, A etc.",
  NR_HEIGHT:"Height in m",
  NR_HEIGHT_HINT:"Height",
  NR_LENGTH:"Length in m",
  NR_LENGTH_HINT:"Length",
  NR_WIDTH:"Width in m",
  NR_WIDTH_HINT:"Width",
  NR_VOLUME_M3:"Volume in m³",
  NR_VOLUME_M3_HINT:"Volume, leave empty to use computed value",
  NR_B_CLOSE:"Close",
  NR_B_CANCEL:"Cancel",
  NR_B_ADD:"Add",

  // Select Room Type component
  SRT_TYPE_OF_LOCATION:"Type of Location",
  SRT_TYPE_OF_LOCATION_HINT:"Room/Area type",

  // Beaconpage
  BP_LAST_UPDATED: lastTime => `Last updated: ${lastTime}`,
  BP_LAST_UPDATED_NEVER: "Last updated: never",
  BP_UNKNOWN_BATTERY: "Unknown battery state",
  BP_UNKNOWN_TEMPERATURE: "Unknown temperature",
  BP_AVAILABLE: "Available",
  BP_LOADING_BEACONS: "Loading beacons...",
  // RegisterBeacon
  BEACON_MEDIA_ERROR: error => `Can't open camera. ${error}`,
  BEACON_BEACONID: "Beacon ID",
  BEACON_BEACONID_HINT: "12 Characters",
  BEACON_CLOSE: "Close",
  BEACON_SCAN_BEACON: "Scan beacon",

  // Machine list
  ML_SEARCH:"Search",
  ML_SEARCH_HINT:"Machine name or id",

  // New machine page
  NM_MACHINE_ID_REQ:"Machine Id (required)",
  NM_MACHINE_ID:"Machine Id",
  NM_MACHINE_ID_HINT:"E.g. 'DECONX34'",
  NM_MACHINE_NAME:"Machine Name",
  NM_MACHINE_NAME_REQ:"Machine Name (required)",
  NM_READABLE_NAME_HINT:"Readable name",
  NM_MODEL_NAME:"Model name",
  NM_MODEL_NAME_REQ:"Model name (required)",
  NM_MODEL_NAME_HINT:"Machine model",
  NM_SERIAL_NO:"Serial number",
  NM_SERIAL_NO_HINT:"Serial number",
  NM_SERIAL_DIB:"Serial num. instr. board",
  NM_SERIAL_DIB_HINT:"Serial Number DIB",
  NM_B_CANCEL:'Cancel',
  NM_B_REGISTER:'Register',

  // Edit room page
  ER_INSUFFICIENT_PERM:"Insufficient permissions",
  ER_H_LOCATION_INFO:"Location information",
  ER_PARENT_LOCATION:"Parent Location",
  ER_LOCATION_TYPE:"Location type",
  ER_LOCATION_NAME:"Location name",
  ER_TL_HEIGHT:"Height",
  ER_TL_LENGTH:"Length",
  ER_TL_WIDTH:"Width",
  ER_TL_VOLUME:"Volume",
  ER_NOT_NUMBER:"Not a valid number",
  ER_DEFAULT_JOB_TYPE:"Default job type",
  ER_LAST_DISINFECTED:"Last disinfected",
  ER_UPDATE_INFO:"Update information",
  ER_NAME_PROMPT: typename => `Name of ${typename}`,
  ER_NAME_PROMPT_REQ: typename => `Name of ${typename} (required)`,
  ER_NAME_PROMPT_HINT:"E.g. 104, A etc.",
  ER_HEIGHT:"Height in m",
  ER_HEIGHT_HINT:"Height",
  ER_LENGTH:"Length in m",
  ER_LENGTH_HINT:"Length",
  ER_WIDTH:"Width in m",
  ER_WIDTH_HINT:"Width",
  ER_COMPUTED_VOL: vol => `Computed volume=${vol} m^3`,
  ER_VOLUME_M3:"Volume in m³",
  ER_VOLUME_M3_HINT:"Volume, leave empty to use computed value",
  ER_H_DELETE_LOCATION:"Delete location",
  ER_DELETE_AREA_AND_CONTAINED_ROOMS:"Delete this area and all rooms contained by it.",
  ER_DELETE_ROOM:"Delete this room",
  ER_AREA_CANNOT_BE_DELETED_HAS_USERS:"Area cannot be deleted as there are users assigned within it.",
  ER_DELETE:'Delete',
  ER_UPDATE:'Update',
  ER_CANCEL:"Cancel",

  // Select default job type component:
  SJT_DEFAULT_JOB_TYPE:"Default job type",
  SJT_DEFAULT_JOB_TYPE_HINT:"Default job type",

  // Hard coded values for some job types.  As new job types are added to
  // the job_type database table, translations needs to be added to the
  // ui_message table with key: JOB_TYPE_DESC_<job_type.id>
  // as seen in these examples :
  'JOB_TYPE_DESC_PREVENTIVE':"Preventive",
  'JOB_TYPE_DESC_PREVENTIVE+':"Preventive+",
  'JOB_TYPE_DESC_6LOG':"6⋅Log<sub>10</sub> disinfection",
  'JOB_TYPE_DESC_6LOG+':"6⋅Log<sub>10</sub>+ disinfection",
  'JOB_TYPE_DESC_FLAT1':"Constant H<sub>2</sub>O<sub>2</sub> level",
  'JOB_TYPE_DESC_4CYCLE90MIN':"Bio.ind-test (4 cycle 90 min)",
  'JOB_TYPE_DESC_FLAT-DX-TEST1':"Bio.ind. test const H<sub>2</sub>O<sub>2</sub>",

  // Select home location component:
  SHL_ALL_AREAS:"All areas.",
  SHL_AREA_USER_WORK_WITHIN:"Area user works within",
  SHL_AREA_USER_WORK_WITHIN_HINT:"Limit user to select area",

  // Set Parent Location component:
  SPL_NOT_CONTAINED_BY_OTHER:"Not contained by other area.",
  SPL_CONTAINING_AREA:"Containing area",
  SPL_ADD_ROOM_WITHIN:"Add room inside",

  // RoleChecker component
  RCHK_H_PERMISSIONS:"Permissions",
  RCHK_ROLE_NAME_SYSTEM_ADMIN:"Decon-X System Admin",
  RCHK_ROLE_NAME_OPERATOR:"Operate machine",
  RCHK_ROLE_NAME_ADMIN:"Edit users",
  RCHK_ROLE_NAME_DISTRIBUTOR:"Edit customers",
  "RCHK_ROLE_NAME_BETA-TESTER":"Beta tester",
  RCHK_ROLE_NAME_LOCATION_ADMIN:"Area administrator",
  RCHK_ROLE_NAME_LOCATION_EDIT:"Edit locations",
  RCHK_ROLE_NAME_USER_EDIT:"Edit users",
  RCHK_ROLE_NAME_OPERATOR_SUPER:"Edit locations from machine",

  // Confirmation messages
  CMSG_SMS_SENT_TO_PHONE: phone => `Test SMS sent to ${phone}`,
  CMSG_REPORT_EMAILED_TO: email => `Report will be emailed to ${email}`,
  CMSG_REPORT_REQUESTED_CHECK_INBOX:"Report requested, check email inbox",
  CMSG_USER_REGISTERED: user =>  `User ${user} registered`,
  CMSG_USER_DELETED: user =>  `User ${user} deleted`,
  CMSG_USER_UPDATED: user =>  `User ${user} updated`,
  CMSG_USER_RESTORED:"User restored",
  CMSG_LOCATION_DELETED: loc =>  `Location ${loc} deleted`,
  CMSG_LOCATION_UPDATED: loc =>  `Location ${loc} updated`,
  CMSG_LOCATION_ADDED: loc =>  `${loc} added`,
  CMSG_LOCATION_RESTORED:"Location restored",
  CMSG_NEW_MACHINE_INSERTED:"New machine inserted",
  CMSG_NEW_CUSTOMER_INSERTED:"New customer inserted",
  CMSG_CUSTOMER_DATA_UPDATED:"Customer data updated",
  CMSG_COULD_NOT_REGISTER_CUSTOMER:"Could not register customer",
  CMSG_CONFIG_STORED:"Configuration stored",
  CMSG_CONFIG_RESET:"Configuration reset",
  CMSG_CONTRACT_UPDATED:"Contract updated",
  CMSG_CONTRACT_INSERTED:"Contract inserted",

  // Job DataModel object:
  JB_JOB_IS_RUNNING:"Job is running",
  JB_SUCCESSFUL_DISINFECT_COMPLETED:"Successful disinfection completed",
  JB_DISINFECTION_COMPLETE_WITH_WARNINGS:"Disinfection completed with warning(s)",
  JB_DISINFECTION_DID_NOT_COMPLETE_SUCCESFULLY:"Disinfection did not complete successfully",
  JB_TIME_REMAIN_UNKNOWN:"Time remaining unknown ",
  JB_LESS_THAN_A_MINUTE:"less than 1 minute",
  JOB_MINUTES_REMAIN: minutes => `${minutes} minutes`,
  JOB_HOURS_MINUTES_REMAIN: (hours, minutes) => `${hours}h ${minutes}min`,

  // Location DataModel object:
  LOC_COMPUTED_VOLUME_DIFFER:"Computed volume differs from manually set volume",
  LOC_MAX_ALLOWED_VOLUME:"Max allowed volume is 250 m³",
  LOC_VOLUME_MUST_BE_VALID_M3:"Volume must be a valid number of m³",
  LOC_BUILDING:'Building',
  LOC_SECTION:'Section',
  LOC_ENTRANCE:'Entrance',
  LOC_AREA:'Area',
  LOC_ROOM:'Room',
  LOC_FLOOR:'Floor',

  // Graph line labels
  REPORT_GRAPH_HUMIDTY:"Humidity [%]",
  REPORT_GRAPH_H2O2:"H₂O₂ [PPM]",
  REPORT_GRAPH_H2O2_EXT:"H₂O₂ ext. [PPM]",
  REPORT_GRAPH_TEMPERATURE:"Temperature [°C]",

  // User manual page:
  UM_HEADING:"Open User Documentation.",
  UM_PAGE_MSG:"Click to open User Documentation in new browser window.",
  UM_PAGE_BUTTON:"Open User Documentation",
  UM_URL:"http://www.deconx.com/about/",
  UM_DX1_QUICK_START_URL:"http://www.deconx.com/about/",
  UM_DX1_QUICK_START:"Decon-X DX1 Quick start guide",
  UM_DX1_USER_GUIDE_URL:"http://www.deconx.com/about/",
  UM_DX1_USER_GUIDE:"Decon-X DX1 User Guide",

  // Audit log
  AL_ENTITY_MACHINE: "Machine",
  AL_ENTITY_LOCATION: "Location",
  AL_ENTITY_CUSTOMER: "Customer",
  AL_ENTITY_CONTRACT: "Contract",
  AL_ENTITY_CUSTOMER_MACHINE: "Machine",
  AL_ENTITY_MACHINE_S: "Machine created/changed",
  AL_ENTITY_MACHINE_D: "Machine deleted",
  AL_ENTITY_LOCATION_S: "Location created/changed",
  AL_ENTITY_LOCATION_D: "Location deleted",
  AL_ENTITY_CUSTOMER_S: "Customer created/changed",
  AL_ENTITY_CUSTOMER_D: "Customer deleted",
  AL_ENTITY_CONTRACT_S: "Contract created/changed",
  AL_ENTITY_CONTRACT_D: "Contract deleted",
  AL_ENTITY_CUSTOMER_MACHINE_S: "Machine allocated",
  AL_FILTER: "Filter",
  AL_FROM: "From",
  AL_FROM_HINT: "From date",
  AL_TO: "To",
  AL_TO_HINT: "To date",
  AL_SELECT_CUSTOMER: "Select customer",
  AL_SELECT_CUSTOMER_HINT: "Select customer",
  AL_SELECT_USER: "Select user",
  AL_SELECT_USER_HINT: "Select user",
  AL_SELECT_ENTITY: "Select entity",
  AL_SELECT_ENTITY_HINT: "Select entity",
  AL_RESET_FILTER: "Reset",
  AL_TABLE_HEADER_TIME: "Time",
  AL_TABLE_HEADER_ENTITY: "Entity",
  AL_TABLE_HEADER_CUSTOMER: "Customer",
  AL_TABLE_HEADER_DATA: "Data",
  AL_TABLE_HEADER_USER: "User",

  MEC_RESET:"Reset",
  MEC_CANCEL:"Cancel",
  MEC_UPDATE:"Update",
  MEC_CONFIRM_RESET:"The configuration will be reset to default configuration. Do you want to proceed?",

  SCD_DATA_USAGE:"Data usage",
  SCD_MONTH:"Month",
  SCD_DATA_PACKAGE:"Data package",
  SCD_SMS_PACKAGE:"SMS package",
  SCD_ROAMING:"Roaming",
  SCD_FREEZE:"Freeze",
  SCD_CANCEL:"Cancel",
  SCD_UPDATE:"Update",
  SCD_API_LIMIT_DESC:"Data package and SMS package can only be changed in the COM4 portal when SIM card is activated",
  SCD_TOTAL_USAGE: (months, amount) => `Total last ${months} months: ${amount} MB`,
  SCD_LOCATION_UPDATE:"Locations last updated:",

  SC_ADD:"Add",
  SC_SHORT_ICCID:"Short ICCID",
  SC_SEARCH_HINT:"ICCID, Name, Status",
  SC_ICCID:"ICCID",
  SC_NAME:"Name",
  SC_STATUS:"Status",
  SC_ICCID_HINT_FIRST:"First ICCID - 89470900000000000000",
  SC_ICCID_HINT_LAST:"Last ICCID - optional",
};

let newLang = observable({version:1});

/*
the uiMsg function should be called for any string that needs to be presented
in the UI and that should be translated between different languages.

It can be called in a simple way :
uiMsg("HP_NO_RUNNING","No running jobs found.")
or with parameters for the message to be formatted
uiMsg("ONLY_ACCEPT","We only accept values between {0} and {1}.",200,300);

@param {string} msg MessageId matching database entry for message definition
@param {string} code_string A hardcoded version of the string.  Not only
                            used to make the code more readable in case the
                            MessageId is too cryptic
@param {any} msgParams If the message definition with input params to format.
*/
export function uiMsg(msg,code_msg,...msgParams) {
  if(newLang.version==100) {
    // We touch the newLang.version attribute to trigger ui refresh if
    // language is changed
    console.log("Language has been changed 100 times.")
  }
  if(!(msg in messages)) {
    console.log("Translation requested for key:"+msg+" but no such message exist in translation list.  Using hard-coded value");
    return code_msg;
  }
  let res = messages[msg];
  if(typeof(res)=='string') return res;
  if(typeof(res)=='function') return res(...msgParams);
  console.error("Message type is neither string nor function for msgId = "+msg);
  return msg;
}

// Returns an array of the message defitions currently installed
export function messageDefinitions() {
  return Object.keys(messages).map(k=> (
    { 'id':k,
      'is_function':typeof(messages[k])=='function',
      'message':messages[k].toString()
    })
  )
}

/*
To change the UI language, pass an array to this function.
Each array entry needs to be an object with the following fields:
msg_key: The unique id of the message
isFunction: True if the message is a function definition
message: Either the text string for the message or the message function.

Message functions will be evaluated and installed.
*/
export function installLanguage(messageDefs) {
  messageDefs.forEach(md => {
    if(!md.message) {
      md.message=md.english_message_as_ref;
    }
    let newFunction=null;
    if(md.is_function) {
      try {
        eval("newFunction="+md.message);
      }
      catch(error) {
        // If the evaluation of the function definition fails, we insert another function that returns "missing translation message"
        console.log("Unable to insert message for "+md.id+" getting exception when trying");
        console.log("Function message definition: "+md.message);
        newFunction=()=>"Invalid translation function for "+md.id;
      }
      messages[md.id]=newFunction;
    }
    else {
      messages[md.id]=md.message;
    }
  })
  // Increase this number to trigger UI refresh for anything that uses
  // translations
  newLang.version=newLang.version+1;
}



/** WEBPACK FOOTER **
 ** ./src/utils/Languages.js
 **/